import React, { Component } from "react";
import { Form, Input, Col, Row } from "antd";
import { UserOutlined, MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import LogoTransparency from "../../Images/LogoTransparency.png";
import backgroundImage from "../../Images/image3.jpg";
import { Auth } from "aws-amplify";
import LoderButton from "../Forgotpassword/LoderButton";
import AppConfig from "../config/AppConfig";
import { checkUser } from "../../Api/Apis";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ isLoading: true });

    const email = String(this.state.email || "").trim();
    if (!email) {
      alert("Please enter your email.");
      this.setState({ isLoading: false });
      return;
    }

    try {
      const entity = AppConfig["entityNames"]["checkUser"];
      const resp = await checkUser(entity, {
      emailId: encodeURIComponent(email),
      profileType: localStorage.getItem("BusinessQuestionnaireId")
        ? "questionnaires"
        : "registrations",
    });

      if (!resp || resp.data?.statusCode !== 1) {
        alert(resp?.data?.message || "User not found!");
        this.setState({ isLoading: false });
        return;
      }

      await Auth.forgotPassword(email);

      localStorage.setItem("forgotEmail", email);
      const fromHeader =
        (this.props.location &&
          this.props.location.state &&
          this.props.location.state.fromHeader) ||
        sessionStorage.getItem("backSrc") === "header";

      this.props.history.push({
        pathname: "/app/CofirmForgotPassword",
        state: { fromHeader },
      });
    } catch (err) {
      console.log("forgotPassword error:", err);
    if (err.code === "InvalidParameterException") {
      alert(
        "This account has no verified email/phone. Please contact support or sign up again with a verified email."
      );
    } else {
      alert(err.message || "Failed to send verification code.");
    }
    } finally {
      this.setState({ isLoading: false });
    }
  };


  render() {
    const fromHeader =
      (this.props.location &&
        this.props.location.state &&
        this.props.location.state.fromHeader) ||
      sessionStorage.getItem("backSrc") === "header";

    return (
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "90.8vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backdropFilter: "blur(6px)",
        }}
      >
        <div
          style={{
            background: "rgba(255, 255, 255, 0.15)",
            boxShadow: "0 8px 32px rgba(31, 38, 135, 0.37)",
            backdropFilter: "blur(10px)",
            borderRadius: "16px",
            border: "1px solid rgba(255, 255, 255, 0.18)",
            padding: "40px",
            width: "380px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <img
            src={LogoTransparency}
            alt="Logo"
            style={{ width: "60%", marginBottom: "20px" }}
          />
          <h2 style={{ color: "#fff", marginBottom: "10px", fontWeight: "600" }}>
            Forgot Password
          </h2>
          <p style={{ color: "#e0e0e0", marginBottom: "30px", fontSize: "14px" }}>
            Verification code will be sent to your registered Email ID
          </p>

          <Form onSubmit={this.handleSubmit}>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please input your email!" },
                { type: "email", message: "Invalid email address!" },
              ]}
            >
              <Input
                prefix={<MailOutlined style={{ color: "#999", padding:'9px' }} />}
                placeholder="Enter your email"
                id="email"
                value={this.state.email}
                onChange={this.handleChange}
                style={{
                  borderRadius: "10px",
                  padding: "10px 12px",
                  border: "1px solid rgba(255,255,255,0.4)",
                  background: "rgba(255,255,255,0.2)",
                  color: "#fff",
                }}
              />
            </Form.Item>

            <LoderButton
              block
              bssize="large"
              type="submit"
              isLoading={this.state.isLoading}
              text="Send Code"
              loadingText="Sending..."
              style={{
                background: "linear-gradient(135deg, #007bff, #00d4ff)",
                color: "#fff",
                borderRadius: "10px",
                fontWeight: "bold",
                height: "40px",
                marginTop: "15px",
              }}
            />

            {!fromHeader && (
              <div style={{ marginTop: "20px" }}>
                <a
                  href="/app/Leadlogin"
                  style={{
                    color: "#cfd8dc",
                    textDecoration: "none",
                    fontSize: "14px",
                  }}
                >
                  <ArrowLeftOutlined /> Back to Login
                </a>
              </div>
            )}
          </Form>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;